<template>
    <div>
        <el-row :gutter="10" class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="($store.state.user.tipo == 4 || $store.state.user.tipo == 5 || $store.state.user.tipo == 6) ? 12 : 24" :md="($store.state.user.tipo == 4 || $store.state.user.tipo == 5 || $store.state.user.tipo == 6) ? 12 : 24">
                <label>Filtrar Ocorrência</label>
                <el-input v-model="filtro['ocorrencia']" placeholder="Pesquisar log..." @keyup.native.enter="changeFiltros"></el-input>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 5 || $store.state.user.tipo == 6">
                <label>Filtrar por Instituição</label>
                <el-select filterable clearable @change="changeFiltros" v-model="filtro.instituicao_id">
                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                </el-select>
            </el-col>
        </el-row>
        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 150px;">Data da Ocorrência</th>
                        <th>Ocorrência</th>
                        <th class="hidden-mobile">Usuário</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ (item.data) ? $moment(item.data).format('DD/MM/YYYY HH:mm:ss') : '' }}</td>
                        <td>{{ item.usuario.name + ' ' + item.ocorrencia }}</td>
                        <td class="hidden-mobile">{{ item.usuario.name }}</td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="40" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: false,
        filtro: {
            ocorrencia: '',
            instituicao_id: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ],
        usuarios: []
    }),
    mounted () {

        if(this.$store.state.user.tipo != 4 && this.$store.state.user.tipo != 5 && this.$store.state.user.tipo != 6 && this.$store.state.config.instituicao){ 
            
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.loadingLogs()
      
    },
    methods: {
        changeFiltros(){

            this.paginate.page = 1;
            this.loadingLogs();
        },
        loadingLogs(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/log/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        deleteLog(id){

            this.$msgbox.confirm('Tem certeza que deseja excluir este log?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/log/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {
                            
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingLogs();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingLogs();
        }
    },
    components:{  }
}
</script>